import React, { useState } from 'react';
import { Form, Row, Col, Button, Container, Alert } from 'react-bootstrap';
import AdminNavbar from '../../Pages/Navbar/AdminNavbar';
import Swal from 'sweetalert2';
import BaseUrl from '../../ApiServices/BaseUrl';
import { FaPlus } from "react-icons/fa";
import './ManageTrainings.css';
import { useNavigate } from 'react-router-dom';

function AddTraining() {
  const [formData, setFormData] = useState({
    training_title: '',
    location: '',
    rating: '',
    description: '',
    our_services: '',
  });
  const navigate = useNavigate();
  const [selectedProfileImage, setSelectedProfileImage] = useState(null);
  const [selectedBackProfileImage, setSelectedBackProfileImage] = useState(null);
  const [profileImagePreview, setProfileImagePreview] = useState(null);
  const [backProfileImagePreview, setBackProfileImagePreview] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleProfileImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedProfileImage(file);
      const previewUrl = URL.createObjectURL(file);
      setProfileImagePreview(previewUrl);
    }
  };

  const handleBackProfileImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedBackProfileImage(file);
      const previewUrl = URL.createObjectURL(file);
      setBackProfileImagePreview(previewUrl);
    }
  };

const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const formDataToSend = new FormData();
      formDataToSend.append('training_title', formData.training_title);
      formDataToSend.append('location', formData.location);
      formDataToSend.append('rating', formData.rating);
      formDataToSend.append('description', formData.description);
      formDataToSend.append('our_services', formData.our_services);
      
      if (selectedProfileImage) {
        formDataToSend.append('profile_image', selectedProfileImage);
      }
      
      if (selectedBackProfileImage) {
        formDataToSend.append('back_profile', selectedBackProfileImage);
      }
      
      const response = await fetch(`${BaseUrl}/trainings`, {
        method: 'POST',
        body: formDataToSend,
      });
      
      if (response.ok) {
        Swal.fire({
          title: 'Success!',
          text: 'Training program created successfully!',
          icon: 'success',
          confirmButtonText: 'OK',
          confirmButtonColor: '#0056a3',
        }).then((result) => {
          if (result.isConfirmed) {
            navigate('/managetrainings');
          }
        });
        
        // Reset form
        setFormData({
          training_title: '',
          location: '',
          rating: '',
          description: '',
          our_services: '',
        });
        setSelectedProfileImage(null);
        setSelectedBackProfileImage(null);
        setProfileImagePreview(null);
        setBackProfileImagePreview(null);
        
        // Clear file inputs
        document.getElementById('formProfileImage').value = '';
        document.getElementById('formBackProfileImage').value = '';
        
      } else {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to create training program');
      }
    } catch (error) {
      Swal.fire({
        title: 'Error!',
        text: 'Error creating training program: ' + error.message,
        icon: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: '#d33',
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <AdminNavbar />
   <Container className="manage-trainings-container" style={{marginTop: "100px"}}>
   <h2 className="training-title-wrapper mb-0">
  <div className="Training-title">
    <span className="training-title-text">Add New Training</span>
  </div>
</h2>


  <div className="form-box mb-5">
    <h2 className="form-title">Create Training Program</h2>
    
    <Form onSubmit={handleSubmit}>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3" controlId="formTrainingTitle">
            <Form.Control 
              type="text" 
              name="training_title"
              placeholder="Training title *" 
              value={formData.training_title}
              onChange={handleInputChange}
              required 
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3" controlId="formLocation">
            <Form.Control 
              type="text" 
              name="location"
              placeholder="Location *" 
              value={formData.location}
              onChange={handleInputChange}
              required 
            />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <Form.Group className="mb-3" controlId="formRating">
            <Form.Control 
              type="text" 
              name="rating"
              placeholder="Rating (e.g., 4.80)" 
              value={formData.rating}
              onChange={handleInputChange}
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3" controlId="formProfileImage">
            <Form.Control 
              type="file" 
              accept="image/*"
              placeholder="Profile image"
              onChange={handleProfileImageChange}
              id="formProfileImage"
            />
            {profileImagePreview && (
              <div className="mt-2">
                <img 
                  src={profileImagePreview} 
                  alt="Profile Preview" 
                  style={{maxWidth: '100%', maxHeight: '200px'}}
                />
              </div>
            )}
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <Form.Group className="mb-3" controlId="formBackProfileImage">
            <Form.Control 
              type="file" 
              accept="image/*"
              placeholder="Back profile image"
              onChange={handleBackProfileImageChange}
              id="formBackProfileImage"
            />
            {backProfileImagePreview && (
              <div className="mt-2">
                <img 
                  src={backProfileImagePreview} 
                  alt="Back Profile Preview" 
                  style={{maxWidth: '100%', maxHeight: '200px'}}
                />
              </div>
            )}
          </Form.Group>
        </Col>
      </Row>

      <Form.Group className="mb-3" controlId="formDescription">
        <Form.Control 
          as="textarea" 
          rows={3} 
          name="description"
          placeholder="Training description *" 
          value={formData.description}
          onChange={handleInputChange}
          required 
        />
      </Form.Group>

      <Form.Group className="mb-3" controlId="formOurServices">
        <Form.Control 
          as="textarea" 
          rows={2} 
          name="our_services"
          placeholder="Our services (comma-separated) *" 
          value={formData.our_services}
          onChange={handleInputChange}
          required 
        />
      </Form.Group>

      <Button 
        variant="primary" 
        type="submit" 
        className="addtraining-submit-btn"
        disabled={isSubmitting}
      >
        {isSubmitting ? 'Creating...' : 'Create Training Program'}
      </Button>
    </Form>
  </div>
</Container>
    </>
  );
}

export default AddTraining;